export const ITEM_CARD_CONFIG_KEY = "web-cab:itemCardConfig";

export const INFO_FIELD_COUNT = 20;
export const PART_INFO_FIELD_COUNT = 4;
export const PART_COMMENT_FIELD_COUNT = 3;

export const DEFAULT_ITEM_CARD_CONFIG = {
  collapseByDefault: false,
  visibleFields: {
    room: true,
    kit: true,
    dimensions: true,
    comment: true,
    barcode: true,
    rfidBarcode: false,
    workOrderName: false,
    packing: true,
    kitBarcode: false,
    weight: false,
    comment2: false,
    comment3: false,
    ...Object.fromEntries(
      Array.from({ length: INFO_FIELD_COUNT }, (_, i) => [
        "info" + (i + 1),
        false,
      ]),
    ),
    partDimensions: false,
    partMaterial: false,
    ...Object.fromEntries(
      Array.from({ length: PART_INFO_FIELD_COUNT }, (_, i) => [
        "partInfo" + (i + 1),
        false,
      ]),
    ),
    ...Object.fromEntries(
      Array.from({ length: PART_COMMENT_FIELD_COUNT }, (_, i) => [
        "partComment" + (i + 1),
        false,
      ]),
    ),
  },
};
